function getAgeOptions(from, to) {
  var opts = [];
  for (var i = from ; i <= to ; i++) {
    opts.push({
      label: i + ' Jahre',
      value: i
    })
  }
  return opts;
}

module.exports = [
  {
    id: 'name',
    type: 'text',
    label: {
      en: 'Patient ID',
      de: 'Patienten ID',
      es: 'Identificación del paciente',
      fr: 'ID du patient',
      pt: 'ID do doente',
      it: 'ID Paziente',
      ru: 'ID пациента'
    },
    readonly: true,
  },
  {
    id: 'sex',
    label: {
      de: 'Geschlecht',
      en: 'Sex',
      es: 'Sexo',
      fr: 'Sexe',
      pt: 'Género',
      it: 'Sesso',
      ru: 'Пол'
    },
    required: true,
    options: [
      {
        label: {
          en: 'Male',
          de: 'Männlich',
          es: 'Varón',
          fr: 'Masculin',
          pt: 'Masculino',
          it: 'maschile',
          ru: 'Мужской'
        },
        // itemnum: '',
        value: 'male'
      },
      {
        label: {
          en: 'Female',
          de: 'Weiblich',
          es: 'Mujer',
          fr: 'Féminin',
          pt: 'Feminino',
          it: 'femminile',
          ru: 'Женский'
        },
        // itemnum: '',
        value: 'female'
      },
      {
        label: {
          en: 'Other',
          de: 'Divers',
          es: 'Otro',
          fr: 'Divers',
          pt: 'Diversos',
          it: 'altro',
          ru: 'Разное'
        },
        // itemnum: '',
        value: 'unknown'
      }
    ]
  },
  {
    id: 'age',
    label: {
      de: 'Alter',
      en: 'Age',
      es: 'Edad',
      fr: 'Age',
      pt: 'Idade',
      it: 'Età',
      ru: 'Возраст'
    },
    suffix: {
      en: 'Years',
      de: 'Jahre',
      es: 'Años',
      fr: 'Ans',
      pt: 'Anos',
      it: 'Anni',
      ru: 'Лет'
    },
    required: true,
    type: 'number',
    min: 10,
    max: 120
    // options: getAgeOptions(4, 130)
  },
  /*
  {
    id: 'reportType',
    label: {
      de: 'Berichtsvorlage',
      en: 'Report type'
    },
    required: true,
    options: [
      {
        label: {
          en: 'Clinic',
          de: 'Klinik'
        },
        itemnum: '17000800',
        value: 'doctor'
      },
      {
        label: {
          en: 'Expert',
          de: 'Experte'
        },
        itemnum: '17000820',
        value: 'expert'
      }
    ]
  },
  */
  {
    id: 'description',
    label: {
      de: 'Eigene Notizen',
      en: 'Personal notes',
      es: 'Notas personales',
      fr: 'Propres notes',
      pt: 'Notas individuais',
      it: 'Note personali',
      ru: 'Заметки'
    },
    type: 'multi'
  }
];
